import React from 'react';
import { IArea } from '../../footdata/clubs/typings';
import '../css/flags.css';

interface IProps {
  country: IArea;
  style?: React.CSSProperties;
}

export default function Flag({ country, style }: IProps) {
  if (!country || !country.codeISO) return null;

  return (
    <i
      className={`flag ${country.codeISO.toLowerCase()}`}
      title={country.name}
      style={style}
    />
  );
}
